import React, { useEffect, useRef } from "react";
import { useVoting } from "../useVoting";

export default function VotingScreen({ words, uid }) {
  const { pair, vote, skip, phase, voteCount } = useVoting(words, uid);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const skipRef = useRef(null);

  function triggerPress(ref) {
    if (!ref.current) return;
    ref.current.classList.add("key-pressed");
    setTimeout(() => ref.current && ref.current.classList.remove("key-pressed"), 200);
  }

  useEffect(() => {
    function handleKey(e) {
      if (!pair) return;
      if (e.key === "ArrowLeft") {
        triggerPress(leftRef);
        setTimeout(() => vote(pair[0].id), 80);
      }
      if (e.key === "ArrowRight") {
        triggerPress(rightRef);
        setTimeout(() => vote(pair[1].id), 80);
      }
      if (e.key === " ") {
        e.preventDefault();
        triggerPress(skipRef);
        setTimeout(() => skip(), 80);
      }
    }
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [pair, vote, skip]);

  return (
    <div className="voting-wrap">
      {voteCount > 0 && (
        <div className="vote-counter">
          {voteCount} vote{voteCount !== 1 ? "s" : ""} cast
        </div>
      )}

      <div className={`voting-screen ${phase === "exit" ? "exiting" : "entering"}`}>
        <p className="prompt-label">Which is funnier?</p>

        <div className="cards-container">
          {pair ? (
            <>
              <button
                ref={leftRef}
                className="word-card"
                onClick={() => vote(pair[0].id)}
                aria-label={`Vote for ${pair[0].word}`}
              >
                <span className="word-card-key">←</span>
                <span className="word-text">{pair[0].word}</span>
              </button>

              <div className="vs-badge">VS</div>

              <button
                ref={rightRef}
                className="word-card"
                onClick={() => vote(pair[1].id)}
                aria-label={`Vote for ${pair[1].word}`}
              >
                <span className="word-card-key">→</span>
                <span className="word-text">{pair[1].word}</span>
              </button>
            </>
          ) : (
            <div className="cards-loading">
              <div className="loading-spinner" />
            </div>
          )}
        </div>

        <button
          ref={skipRef}
          className="skip-btn"
          onClick={skip}
          disabled={!pair}
        >
          ↷ skip this pair
        </button>

        <div className="keyboard-hint">
          <kbd>←</kbd> left word &nbsp;·&nbsp; <kbd>→</kbd> right word &nbsp;·&nbsp; <kbd>space</kbd> to skip
        </div>
      </div>
    </div>
  );
}
